import { Paper, Typography, useTheme } from "@mui/material";
import useStyles from "./styles";
import { ArrowDropDown, ArrowForward, EventNote } from "@mui/icons-material";
import { useState } from "react";
import ModalDateTime from "./modalDateTime";

interface DateFilterProps {
  value: dateFilter;
  onChange: (filters: dateFilter) => void;
  onClose: () => void;
  disabled?: boolean;
}
export type Option = {
  value: number;
  unit: string;
  unitEn: string;
  type: "ago" | "previous" | "current";
};
export interface CustomFiltersDateRef {
  resetFilterDate: () => any;
}
const DateFilter: React.FC<DateFilterProps> = (props) => {
  const { value, onChange, onClose, disabled } = props;
  const theme = useTheme();
  let { timeStart, timeEnd, option } = value ?? {
    timeStart: new Date(),
    timeEnd: new Date().getMonth() - 1,
  };
  timeStart = timeStart
    ? new Date(timeStart)
    : new Date(new Date().setMonth(new Date().getMonth() - 1));
  timeEnd = timeEnd ? new Date(timeEnd) : new Date();
  const styles = useStyles(theme);
  const [anchorElDate, setAnchorElDate] = useState<HTMLDivElement | null>(null);
  const optionsTimesRange: Option[] = [
    { value: 5, unit: "minutos", unitEn: "minutes", type: "ago" },
    { value: 15, unit: "minutos", unitEn: "minutes", type: "ago" },
    { value: 30, unit: "minutos", unitEn: "minutes", type: "ago" },
    { value: 1, unit: "hora", unitEn: "hour", type: "ago" },
    { value: 3, unit: "horas", unitEn: "hours", type: "ago" },
    { value: 6, unit: "horas", unitEn: "hours", type: "ago" },
    { value: 12, unit: "horas", unitEn: "hours", type: "ago" },
    { value: 24, unit: "horas", unitEn: "hours", type: "ago" },
    { value: 2, unit: "dias", unitEn: "days", type: "ago" },
    { value: 7, unit: "dias", unitEn: "days", type: "ago" },
    { value: 30, unit: "dias", unitEn: "days", type: "ago" },
    // { value: 1, unit: "mês", unitEn: "month" , type: "ago"},
    { value: 3, unit: "meses", unitEn: "months", type: "ago" },
    { value: 6, unit: "meses", unitEn: "months", type: "ago" },
    { value: 1, unit: "ano", unitEn: "year", type: "ago" },
    { value: 2, unit: "anos", unitEn: "year", type: "ago" },
    { value: 5, unit: "anos", unitEn: "year", type: "ago" },
    { value: 1, unit: "semana", unitEn: "week", type: "previous" },
    { value: 1, unit: "mês", unitEn: "month", type: "previous" },
    { value: 1, unit: "ano", unitEn: "year", type: "previous" },
    { value: 1, unit: "semana", unitEn: "week", type: "current" },
    { value: 1, unit: "mês", unitEn: "month", type: "current" },
    { value: 1, unit: "ano", unitEn: "year", type: "current" },
  ];
  //previous, current, ago
  const handleClick = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>,
  ): void => {
    setAnchorElDate(event.currentTarget);
  };

  const textOptions = (option: Option) => {
    if (option.type === "ago") {
      return ` ${option.value} ${option.unit} atrás`;
    }
    if (option.type === "current") {
      return `${option.unit} atual`;
    }
    if (option.type === "previous") {
      return `${option.unit} anterior`;
    }
  };
  return (
    <>
      <Paper sx={styles.paper} onClick={(e) => handleClick(e)}>
        <EventNote sx={{ fontSize: 20, color: "text.secondary" }} />
        {option ? (
          <>
            <Typography>{textOptions(option)}</Typography>
          </>
        ) : (
          <>
            <Typography sx={styles.typography}>
              {timeStart.toLocaleDateString("pt-BR", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
              })}
            </Typography>
            <ArrowForward sx={{ fontSize: 20, color: "text.secondary" }} />
            <Typography sx={styles.typography}>
              {timeEnd.toLocaleDateString("pt-BR", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
              })}
            </Typography>
          </>
        )}

        <ArrowDropDown sx={{ fontSize: 20, color: "text.secondary" }} />
      </Paper>
      <ModalDateTime
        optionsTimesRange={optionsTimesRange}
        key={"modalDate"}
        anchorEl={anchorElDate}
        setAnchorEl={setAnchorElDate}
        value={value}
        onChange={onChange}
        onClose={onClose}
        disabled={disabled}
      />
    </>
  );
};
export default DateFilter;
